import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Amount } from '@welldev-group/react-comp-lib';

const CostsListItem = ({
  className,
  title,
  hint,
  amount,
  highlighted,
  currency,
  showItem,
}) =>
  showItem ? (
    <li className={classNames('costs-list__item', className)}>
      <div className="costs-list__item-description">
        <div className="costs-list__item-description-title">{title}</div>
        {hint && (
          <div className="costs-list__item-description-help-text">{hint}</div>
        )}
      </div>
      <div
        className={classNames('costs-list__item-price', {
          'costs-list__item-price--total': highlighted,
        })}
      >
        <Amount
          minFractionDigit={2}
          currency={currency}
          value={amount}
          returnStringOnly={true}
        />
      </div>
    </li>
  ) : null;

CostsListItem.defaultProps = {
  className: '',
  title: '',
  hint: '',
  amount: '',
  highlighted: false,
  currency: 'USD',
  showItem: true,
};

CostsListItem.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  hint: PropTypes.string,
  amount: PropTypes.string,
  highlighted: PropTypes.bool,
  currency: PropTypes.string,
  showItem: PropTypes.bool,
};

export default CostsListItem;
